import Axios from "axios";
import { RATE_LIMIT_EXCEEDED } from "./api-error-types";

export const AUTH_EMAIL_COOLDOWN_SECONDS = 60;

export const isRateLimitError = (error: unknown): boolean => {
    if (!Axios.isAxiosError(error)) {
        return false;
    }

    const status =
        error.response?.status ??
        (error.response?.data as { status?: number } | undefined)?.status;
    const type = (error.response?.data as { type?: string } | undefined)?.type;

    return status === 429 || type === RATE_LIMIT_EXCEEDED;
};

/**
 * Prefer server Retry-After (header or body) over the default client cooldown.
 */
export const getRetryAfterSeconds = (
    error: unknown,
    fallback: number = AUTH_EMAIL_COOLDOWN_SECONDS
): number => {
    if (!Axios.isAxiosError(error)) {
        return Math.max(1, Math.ceil(fallback));
    }

    const headers = error.response?.headers ?? {};
    const headerValue = headers["retry-after"] ?? headers["Retry-After"];
    const fromHeader =
        headerValue != null ? Number.parseInt(String(headerValue), 10) : NaN;

    const body = error.response?.data as
        | { retryAfterSeconds?: number | string }
        | undefined;
    const fromBody =
        body?.retryAfterSeconds != null ? Number(body.retryAfterSeconds) : NaN;

    const value =
        Number.isFinite(fromHeader) && fromHeader > 0
            ? fromHeader
            : Number.isFinite(fromBody) && fromBody > 0
            ? fromBody
            : fallback;

    return Math.max(1, Math.ceil(value));
};
